import css from './styles.module.css'

export const FolderLinkCls = {
  wrapper: css.link,
  icon: css.icon,
  text: css.text_wrap,
  title: css.title,
}
